// extracted by mini-css-extract-plugin
export default {"root":"BrandInfo_root__t-puu","content":"BrandInfo_content__2adEW","logo":"BrandInfo_logo__1amkA","description":"BrandInfo_description__3Mza4"};